<itl-wizard-page
  [pageTitleTransPath]="'components.swodoc.email-on-complete.modal.title'"
  [pageIsValid]="true"
  [isSinglePage]="true"
  (cancelClicked)="cancel()"
  (doneClicked)="send()"
>
  <itl-info-box
    >Dein Dokument wird automatisiert an das Dokumentenmanagement-System übertragen. Wenn du es noch an weitere
    Empfänger verschicken möchtest, kannst du hier die E-Mail-Adressen angeben.</itl-info-box
  >
  <form [formGroup]="form">
    <itl-checkbox-select
      icon="alberta-mail"
      [title]="'components.swodoc.email-on-complete.modal.selectMails' | translate"
      [headerText]="'components.swodoc.email-on-complete.modal.selectMails' | translate"
      [selectionItems]="contactSelectionItems"
      formControlName="selectedContacts"
      [disabled]="emailSelectionDisabled"
    ></itl-checkbox-select>
    <itl-text
      icon="alberta-mail"
      [title]="'components.swodoc.email-on-complete.modal.addMailSelf' | translate"
      [description]="'components.swodoc.email-on-complete.modal.addMailSelfDescription' | translate"
      formControlName="individualMail"
    ></itl-text>
  </form>
</itl-wizard-page>
